import { useCreativeTypes, useGetMassCreativeAddTask } from 'domains/creative/model/selectors';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatchApp } from 'redux/rootSelectors';
import { featchAllCreativeTypesAction, fetchMassCreativeAddTask } from 'domains/creative/reduser';
import { useHistory, useLocation } from 'react-router';
import { useUploadModal } from './useUploadModal';
import { TUsePackageUploadModal, UPLOADSTAGELIST } from '../types';

export const usePackageUploadModal: TUsePackageUploadModal = ({ xxhash, task_id }) => {
  const dispatch = useDispatchApp();
  const history = useHistory();
  const location = useLocation();

  const { t } = useTranslation();
  const { data: task, isLoading: isTaskLoading } = useGetMassCreativeAddTask();
  const { data: creativeTypes } = useCreativeTypes();

  // Получаем ШАГ и управление через редьюсер, местного значения
  const { step, isLoading, uploadDispatch } = useUploadModal();

  const [files, setFiles] = useState<File[]>([]);
  const [textError, setTextError] = useState<string>('');
  // У нас такая логика, если все файлы - ок, сразу открываем зеленый, если хотя бы один не ОК - красный
  const [openId, setOpenId] = useState<'green' | 'red' | undefined>('green');

  // Обработчик клика по шапке списка
  const handleToggle = (id: 'green' | 'red' | undefined) => {
    setOpenId((prev) => (prev === id ? undefined : id)); // если кликнули на открытый — закрываем, иначе открываем новый
  };

  useEffect(() => {
    // Проверяем, находится ли мы в одном из этих этапов
    // ResultSuccess - все файлы ОК
    // ResultError - все файлы НЕ ОК
    // ResultPartial - некоторые файлы НЕ ОК
    const isResultStage = [
      UPLOADSTAGELIST.ResultSuccess,
      UPLOADSTAGELIST.ResultError,
      UPLOADSTAGELIST.ResultPartial,
    ].some((allowedStep) => allowedStep === step);

    if (isResultStage) {
      if (step === UPLOADSTAGELIST.ResultSuccess) setOpenId('green');
      else setOpenId('red');
    }
  }, [step]);

  useEffect(() => {
    if (!xxhash && task_id) {
      dispatch(fetchMassCreativeAddTask({ task_id }));
    }
  }, [xxhash, task_id]);

  useEffect(() => {
    dispatch(featchAllCreativeTypesAction());
  }, []);

  useEffect(() => {
    if (!xxhash && task && task.status === 'done') {
      const errorCount = Number(task.error_creative?.count) || 0;
      const successCount = Number(task.successful_creative?.count) || 0;

      if (errorCount === 0 && successCount > 0) {
        uploadDispatch({ type: 'UPLOAD_SUCCESS' });
      } else if (errorCount > 0 && successCount > 0) {
        uploadDispatch({ type: 'UPLOAD_PARTIAL' });
      }
    } else if (!xxhash && task && task.status === 'error') {
      uploadDispatch({ type: 'UPLOAD_ERROR' });
    }
  }, [xxhash, task]);

  useEffect(() => {
    if (task?.error) {
      uploadDispatch({ type: 'ARCHIVE_ERROR' });
      setTextError(task.error);
    };
  }, [task]);

  return {
    t,
    dispatch,
    history,
    step,
    isLoading,
    uploadDispatch,
    files,
    setFiles,
    openId,
    handleToggle,
    task,
    isTaskLoading,
    textError,
    setTextError,
    creativeTypes,
    location,
  };
};
